import { HttpHeaders } from '@angular/common/http';

export const contentHeaders: HttpHeaders = new HttpHeaders({
  'Accept': 'application/json',
  'Content-Type': 'application/json',
});
// contentHeaders.append('Accept', 'application/json');
// contentHeaders.append('Content-Type', 'application/json');

export const contentXWWWHeaders: HttpHeaders = new HttpHeaders({
  'Accept': 'application/x-www-form-urlencoded',
  'Content-Type': 'application/x-www-form-urlencoded',
});
